var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EnzymeEnum } from "./RnaCatalog";
var MultiplexKitSerializer = /** @class */ (function () {
    function MultiplexKitSerializer(comment, plexity, prefilled, protocolType, config, scale, detectPresetScale, chromogenPresetScale) {
        var _this = this;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setDetectState = function (state) {
            _this.detectState = state;
        };
        this.serializeKit = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
            var kit = {
                protocolType: (_a = _this.platform) === null || _a === void 0 ? void 0 : _a.id,
                config: _this.config,
                plexity: _this.plexity,
                comment: _this.comment,
                starterKit: false
            };
            if (_this.probeSetState) {
                kit.probeSetComponent = _this.probeSetState.map(function (s) {
                    return MultiplexKitSerializer.serializeProbeComponent(s.state, s.channel, s.metadata, _this.scale);
                });
            }
            else {
                kit.probeSetComponent = [];
            }
            if (_this.detectState) {
                kit.detectComponent = {
                    _type: 'pro',
                    prefilled: _this.prefilled,
                    proDetectPresetScaleId: (_c = (_b = _this.detectPresetScale) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null,
                    customScaleSlides: ((_d = _this.detectPresetScale) === null || _d === void 0 ? void 0 : _d.id) == null ? _this.scale : null,
                    pretreatADewaxUl: (_f = (_e = _this.detectPresetScale) === null || _e === void 0 ? void 0 : _e.pretreatADewaxUl) !== null && _f !== void 0 ? _f : 0,
                    pretreatBAntigenRetrievalUl: (_h = (_g = _this.detectPresetScale) === null || _g === void 0 ? void 0 : _g.pretreatBAntigenRetrievalUl) !== null && _h !== void 0 ? _h : 0,
                    pretreatBloxolUl: (_k = (_j = _this.detectPresetScale) === null || _j === void 0 ? void 0 : _j.pretreatBloxolUl) !== null && _k !== void 0 ? _k : 0,
                    detectAUl: (_m = (_l = _this.detectPresetScale) === null || _l === void 0 ? void 0 : _l.detectAUl) !== null && _m !== void 0 ? _m : 0,
                    detectBUl: (_p = (_o = _this.detectPresetScale) === null || _o === void 0 ? void 0 : _o.detectBUl) !== null && _p !== void 0 ? _p : 0,
                    detectBPmol: (_r = (_q = _this.detectPresetScale) === null || _q === void 0 ? void 0 : _q.detectBPmol) !== null && _r !== void 0 ? _r : 0,
                    detectBConcentration: (_t = (_s = _this.detectPresetScale) === null || _s === void 0 ? void 0 : _s.detectBConcentration) !== null && _t !== void 0 ? _t : 0,
                    detectCUl: (_v = (_u = _this.detectPresetScale) === null || _u === void 0 ? void 0 : _u.detectCUl) !== null && _v !== void 0 ? _v : 0,
                    postProcessAUl: (_x = (_w = _this.detectPresetScale) === null || _w === void 0 ? void 0 : _w.postProcessAUl) !== null && _x !== void 0 ? _x : 0,
                    postProcessBUl: (_z = (_y = _this.detectPresetScale) === null || _y === void 0 ? void 0 : _y.postProcessBUl) !== null && _z !== void 0 ? _z : 0,
                    preHybridizationUl: (_1 = (_0 = _this.detectPresetScale) === null || _0 === void 0 ? void 0 : _0.preHybridizationUl) !== null && _1 !== void 0 ? _1 : 0,
                    channels: _this.detectState.map(function (s) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                        return {
                            amplifier: (_b = (_a = s.state.enzymeCompatibility) === null || _a === void 0 ? void 0 : _a.amplifier) === null || _b === void 0 ? void 0 : _b.id,
                            hapten: (_d = (_c = s.state.enzymeCompatibility) === null || _c === void 0 ? void 0 : _c.hapten) === null || _d === void 0 ? void 0 : _d.id,
                            detectAntiHaptenUl: (_f = (_e = _this.detectPresetScale) === null || _e === void 0 ? void 0 : _e.detectAntiHaptenUl) !== null && _f !== void 0 ? _f : 0,
                            detectTyramideUl: (_h = (_g = _this.detectPresetScale) === null || _g === void 0 ? void 0 : _g.detectTyramideUl) !== null && _h !== void 0 ? _h : 0,
                            detectHrpQuencherUl: (_k = (_j = _this.detectPresetScale) === null || _j === void 0 ? void 0 : _j.detectHrpQuencherUl) !== null && _k !== void 0 ? _k : 0,
                            detectEnzymeApUl: ((_m = (_l = s.state.enzymeCompatibility) === null || _l === void 0 ? void 0 : _l.enzyme) === null || _m === void 0 ? void 0 : _m.id) !== EnzymeEnum.HRP ? ((_p = (_o = _this.detectPresetScale) === null || _o === void 0 ? void 0 : _o.detectEnzymeApUl) !== null && _p !== void 0 ? _p : 0) : 0,
                            detectEnzymeHrpUl: ((_r = (_q = s.state.enzymeCompatibility) === null || _q === void 0 ? void 0 : _q.enzyme) === null || _r === void 0 ? void 0 : _r.id) !== EnzymeEnum.AP ? ((_t = (_s = _this.detectPresetScale) === null || _s === void 0 ? void 0 : _s.detectEnzymeHrpUl) !== null && _t !== void 0 ? _t : 0) : 0,
                            enzyme: (_v = (_u = s.state.enzymeCompatibility) === null || _u === void 0 ? void 0 : _u.enzyme) === null || _v === void 0 ? void 0 : _v.id,
                            channel: s.channel
                        };
                    })
                };
                // Only one plex kit can have a chromogen
                if (_this.detectState.length === 1) {
                    kit.chromogenComponent = MultiplexKitSerializer.serializeChromogen(_this.chromogenPresetScale, (_2 = _this.detectState[0]) === null || _2 === void 0 ? void 0 : _2.state.chromogen, _this.scale);
                }
            }
            return {
                _type: 'rna-cish',
                kit: kit
            };
        };
        this.comment = comment;
        this.plexity = plexity;
        this.prefilled = prefilled;
        this.platform = protocolType;
        this.config = config;
        this.scale = scale;
        this.detectPresetScale = detectPresetScale;
        this.chromogenPresetScale = chromogenPresetScale;
    }
    MultiplexKitSerializer.serializeProbeComponent = function (proKitProbeState, channel, presetScale, scale) {
        var _a, _b, _c, _d, _e;
        var organism = proKitProbeState.organism;
        var target = proKitProbeState.target;
        var hcrAmplifier = proKitProbeState.hcrAmplifier;
        var probeSetComponent;
        // Catalog Probe Set
        if (target.variantId != null) {
            var variant = target.variantId;
            probeSetComponent = {
                probeSet: {
                    _type: "catalog",
                    hcrAmplifier: hcrAmplifier.id,
                    id: variant,
                    customerOrganismName: organism.displayName(),
                    customerTargetName: target.name,
                    customerAccessionNum: target.accession,
                    customerSequence: target.targetMrnaSeq,
                    customerProbeSetSize: target.probeSetSize
                }
            };
        }
        // Library Organism Custom Target
        else if (organism.id !== -1) {
            probeSetComponent = {
                probeSet: {
                    _type: "libraryOrganismCustomTarget",
                    organism: {
                        id: organism.id
                    },
                    target: {
                        name: target.name,
                        accession: target.targetMrnaSeq === "" ? "Need target sequence or accession" : "",
                        targetMrnaSeq: target.targetMrnaSeq
                    },
                    hcrAmplifier: hcrAmplifier.id,
                    probeSetSize: target.probeSetSize
                }
            };
        }
        // Other Organism Custom Target
        else {
            probeSetComponent = {
                probeSet: {
                    _type: "otherOrganismCustomTarget",
                    organism: {
                        name: organism.name
                    },
                    target: {
                        name: target.name,
                        accession: target.targetMrnaSeq === "" ? "Need target sequence or accession" : "",
                        targetMrnaSeq: target.targetMrnaSeq
                    },
                    hcrAmplifier: hcrAmplifier.id,
                    probeSetSize: target.probeSetSize
                }
            };
        }
        probeSetComponent = __assign(__assign({}, probeSetComponent), { _type: 'pro', channel: channel, presetScaleId: (_a = presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) !== null && _a !== void 0 ? _a : null, customScaleSlides: (presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) == null ? scale : null, pmol: (_b = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeSetScalePmol) !== null && _b !== void 0 ? _b : 0, volume: (_c = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeSetScaleUl) !== null && _c !== void 0 ? _c : 0, probeHybridizationAScaleUl: (_d = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeHybridizationBufferUl) !== null && _d !== void 0 ? _d : 0, probeHybridizationBScaleUl: (_e = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeHybridizationBufferUl) !== null && _e !== void 0 ? _e : 0 });
        return probeSetComponent;
    };
    MultiplexKitSerializer.serializeChromogen = function (chromogenPresetScale, chromogen, scale) {
        var _a, _b, _c, _d;
        var effectiveChromogen = chromogen !== null && chromogen !== void 0 ? chromogen : chromogenPresetScale === null || chromogenPresetScale === void 0 ? void 0 : chromogenPresetScale.chromogen;
        if (effectiveChromogen != null && effectiveChromogen.id !== 'NONE') {
            return {
                presetScaleId: (_a = chromogenPresetScale === null || chromogenPresetScale === void 0 ? void 0 : chromogenPresetScale.id) !== null && _a !== void 0 ? _a : null,
                customScaleSlides: (chromogenPresetScale === null || chromogenPresetScale === void 0 ? void 0 : chromogenPresetScale.id) == null ? scale : null,
                chromogenId: effectiveChromogen.id,
                chromogenBufferId: effectiveChromogen.bufferCompatibility.id,
                chromogenScaleUl: (_b = chromogenPresetScale === null || chromogenPresetScale === void 0 ? void 0 : chromogenPresetScale.chromogenScaleUl) !== null && _b !== void 0 ? _b : 0,
                chromogenBufferScaleUl: (_c = chromogenPresetScale === null || chromogenPresetScale === void 0 ? void 0 : chromogenPresetScale.chromogenBufferScaleUl) !== null && _c !== void 0 ? _c : 0,
                hematoxylinScaleUl: (_d = chromogenPresetScale === null || chromogenPresetScale === void 0 ? void 0 : chromogenPresetScale.hemotoxylinScaleUl) !== null && _d !== void 0 ? _d : 0
            };
        }
        else {
            return null;
        }
    };
    return MultiplexKitSerializer;
}());
export default MultiplexKitSerializer;
//# sourceMappingURL=MultiplexKitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/MultiplexKitSerializer.js
// module id = 1151
// module chunks = 0